import { render, staticRenderFns } from "./TabPurchaseCompleted.vue?vue&type=template&id=f9dfb4c2&scoped=true&"
import script from "./TabPurchaseCompleted.vue?vue&type=script&lang=js&"
export * from "./TabPurchaseCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dfb4c2",
  null
  
)

export default component.exports